import React, { ReactNode, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import Orderbook from './Orderbook/Orderbook';
import {
	Trade,
	OrderBook,
	RecentTrades as RecentTradesIcon,
} from '@drift-labs/icons';
import { svgGradientFill } from 'src/constants/styleConstants';
import { FEATURE_FLAGS } from '@drift/common';
import CandleTypeSelector from './TradingView/CandleTypeSelector';
import RecentMarketTrades from './RecentMarketTrades';

type MobileTradeTab = 'chart' | 'orderbook' | 'recentTrades';

const TVChartContainer = dynamic(
	() =>
		import('./TradingView').then(
			(mod) =>
				mod.TVChartContainer as React.ComponentType<{ isMobile?: boolean }>
		),
	{ ssr: false }
);

const SelectorButton = (props: {
	onClick: () => void;
	selected?: boolean;
	children: ReactNode;
}) => {
	return (
		<button
			onClick={props.onClick}
			className={`text-text-label border border-container-border px-4 py-2 flex flex-row items-center justify-center first-child:rounded-l last-child:rounded-r ${
				props.selected ? 'rainbow-gradient-border' : ''
			}`}
		>
			{props.children}
		</button>
	);
};

const MobileChartAndOrderbook = () => {
	const controlsRef = useRef<HTMLDivElement>(null);
	const [selectedTab, setSelectedTab] = useState<MobileTradeTab>('chart');

	const orderbookHeight = `calc(100% - ${
		controlsRef?.current?.clientHeight ?? 0
	}px`;

	return (
		<div className="h-full flex flex-col relative">
			<div
				className={`h-[360px] sm:h-full w-full bg-container-bg ${
					selectedTab !== 'chart' ? 'hidden' : ''
				}`}
			>
				<TVChartContainer isMobile />
			</div>
			<div
				className={`h-[360px] sm:h-full w-full bg-container-bg ${
					selectedTab !== 'orderbook' ? 'hidden' : ''
				}`}
			>
				<Orderbook />
			</div>
			<div
				style={{ height: orderbookHeight }}
				className={`h-[360px] sm:h-full w-full bg-container-bg ${
					selectedTab !== 'recentTrades' ? 'hidden' : ''
				}`}
			>
				<div className="flex flex-col h-[360px] sm:h-full">
					<RecentMarketTrades />
				</div>
			</div>
			<div
				className="flex flex-row justify-between p-3 bg-container-bg-hover"
				ref={controlsRef}
			>
				<div className="flex flex-row">
					<SelectorButton
						onClick={() => setSelectedTab('chart')}
						selected={selectedTab === 'chart'}
					>
						<Trade
							size={20}
							color={selectedTab === 'chart' ? svgGradientFill : undefined}
						/>
					</SelectorButton>
					<SelectorButton
						onClick={() => setSelectedTab('orderbook')}
						selected={selectedTab === 'orderbook'}
					>
						<OrderBook
							size={20}
							color={selectedTab === 'orderbook' ? svgGradientFill : undefined}
						/>
					</SelectorButton>
					<SelectorButton
						onClick={() => setSelectedTab('recentTrades')}
						selected={selectedTab === 'recentTrades'}
					>
						<RecentTradesIcon
							size={20}
							color={
								selectedTab === 'recentTrades' ? svgGradientFill : undefined
							}
						/>
					</SelectorButton>
				</div>

				{selectedTab === 'chart' && FEATURE_FLAGS.UI_ORACLE_CANDLES && (
					<CandleTypeSelector isMobile />
				)}
			</div>
		</div>
	);
};

export default MobileChartAndOrderbook;
